<template>
  <div>
    <warehouse-handling-tabs></warehouse-handling-tabs>
    <m-form
        style="margin-top: -20px"
        :title="title"
        :showList="false"
        :listRoute="{ name: 'WarehouseHandlingList' }"
        exportBaseUrl="reports/lists/warehouseHandlings"
        :exportParams="{ id: this.id }"
        :canDelete="canDelete"
        :canSubmit="canSubmit"
        :isEditing.sync="isEditing"
        @goToForm="getItemByPosition"
        @submit="submit"
        @delete="deleteItem"
        @clearForm="clearForm()"
        ref="mForm"
    >
      <template #header-btns>
        <template v-if="item.is_defined">
          <span class="mr-3 ml-3">
            <v-btn
                v-if="item.inputAdjustment"
                depressed
                :to="{
                name: 'AdjustmentForm',
                params: { id: item.inputAdjustment, type: 'ia' },
              }"
                class="primary white--text mr-1 mt-1 mt-md-0 rounded-lg"
            >مشاهده رسید</v-btn>

            <v-btn
                v-if="item.outputAdjustment"
                depressed
                :to="{
                name: 'AdjustmentForm',
                params: { id: item.outputAdjustment, type: 'oa' },
              }"
                class="primary white--text mr-1 mt-1 mt-md-0 rounded-lg"
            >مشاهده حواله</v-btn>
          </span>
        </template>

        <template v-if="$refs.mForm && id">
          <span class="mr-2 ml-3">
            <v-btn
                depressed
                :block="isXs"
                small
                class="export-btn mr-1 mt-1 mt-md-0 rounded-lg"
                :href="$refs.mForm.printUrl + '&hide_remains=true'"
                target="_blank"
                rel="noopener noreferrer"
            >چاپ بدون مانده</v-btn
            >
            <v-btn
                depressed
                small
                class="export-btn mr-1 mt-1 mt-md-0 rounded-lg"
                :href="$refs.mForm.pdfUrl + '&hide_remains=true'"
                rel="noopener noreferrer"
            >PDF بدون مانده</v-btn
            >
            <v-btn
                depressed
                small
                class="export-btn mr-1 mt-1 mt-md-0 rounded-lg"
                @click="downloadUrl($refs.mForm.excelUrl + '&hide_remains=true')"
            >اکسل بدون مانده</v-btn
            >
          </span>
        </template>
      </template>

      <template>
        <v-row >
          <v-col cols="12" md="1">
            <div id="warehouse-handling-code">
              <v-text-field class="rounded-lg" disabled label="شماره" v-model="item.code"/>
            </div>
          </v-col>
          <v-col cols="12" md="2">
            <div id="warehouse-handling-start-date">
              <date  v-model="item.start_date"
                    label=" * تاریخ آغاز" :default="true" :disabled="!isEditing"/>
            </div>
          </v-col>
          <v-col cols="12" md="2">
            <date id="warehouse-handling-counting-date" v-model="item.counting_date"
                  label=" * تاریخ شمارش" :default="true" :disabled="!isEditing"/>
          </v-col>
          <v-col cols="12" md="2">
            <date id="warehouse-handling-submit-date" v-model="item.submit_date"
                  label=" * تاریخ ثبت انبار گردانی" :default="true" :disabled="!isEditing"/>
          </v-col>
          <v-col cols="12" md="2">
            <div id="warehouse-handling-submit-time">
              <mtime label="* ساعت ثبت انبار گردانی" v-model="item.submit_time" :default="true" :disabled="!isEditing"/>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div id="warehouse-handling-explanation">
              <v-textarea class="rounded-lg" label="شرح"  height="100"
                          v-model="item.explanation" :disabled="!isEditing"/>
            </div>
          </v-col>

          <v-col cols="12" md="3" style="margin-top: -70px">
            <div id="warehouse-handling-inventory-clerk">
              <v-autocomplete
                  class="rounded-lg"
                  :return-object="false"
                  label="* انبار گردان"
                  :items="inventoryClerks"
                  v-model="item.handler"
                  item-text="name"
                  item-value="id"
                  :disabled="!isEditing"
              >
              </v-autocomplete>
            </div>
          </v-col>
          <v-col cols="12" md="3" style="margin-top: -70px">
            <div id="warehouse-handling-warehouse">
              <v-autocomplete
                  class="rounded-lg"
                  :return-object="false"
                  label="* انبار"
                  :items="warehouses"
                  v-model="filters.warehouse"
                  item-text="title"
                  item-value="id"
                  :disabled="id != undefined"
              />
            </div>
          </v-col>

          <v-col cols="12" md="3" style="margin-top: -70px">
            <div id="warehouse-handling-ware-status">
              <v-select
                  :menu-props="{ bottom: true, offsetY: true }"
                  class="rounded-lg"
                  :items="waresStatuses"
                  v-model="filters.status"
                  label="وضعیت کالا"
                  :disabled="id != undefined"
              />
            </div>
          </v-col>
          <v-col cols="12">
            <input-table v-model="rows" v-if="filters.warehouse">
              <template #thead>
                <tr>
                  <th>#</th>
                  <th>کد کالا</th>
                  <th>نام کالا</th>
                  <th>واحد</th>
                  <th width="150px">* موجودی شمارش شده انبار</th>
                  <th>مانده سیستم</th>
                  <th>مغایرت</th>
                  <th>توضیحات</th>
                </tr>
              </template>
              <template #tbody v-if="inventory.length">
                <tr v-for="(row, i) in rows" :key="i">
                  <td class="tr-counter">{{ i + 1 }}</td>
                  <td>{{ row.ware.code }}</td>
                  <td>{{ row.ware.name }}</td>
                  <td>{{ row.ware.unit }}</td>
                  <td>
                    <money v-model="row.warehouse_remain" :disabled="!isEditing"/>
                  </td>
                  <td>{{ getSystemRemain(row) | toMoney }}</td>
                  <td dir="ltr" :class="getContradictionStyle(row)">
                    {{ getContradiction(row) | toMoney }}
                  </td>
                  <td>
                    <row-textarea
                        class="rounded-lg"
                        v-model="row.explanation"
                        :disabled="!isEditing"
                        :i="i"
                        @updateRowsExplanation="updateRowsExplanation"
                    />
                  </td>
                </tr>
              </template>
            </input-table>
          </v-col>
        </v-row>
      </template>

      <template #footer-outside-btns>
        <v-btn
            v-if="id"
            depressed
            @click="definite"
            :disabled="item.is_defined"
            class="accent rounded-lg white--text mr-1"
        >ثبت نهایی
        </v-btn>
      </template>
    </m-form>

    <v-dialog
        class="rounded-lg"
        v-model="errorDialog.show"
        scrollable
        max-width="1200px"
        transition="dialog-transition"
        :fullscreen="isPrinting"
    >
      <v-card class="rounded-lg pa-2">
        <v-card-title class="error--text"> عملیات با خطا های زیر به رو شد</v-card-title>

        <v-card-text>
          <v-simple-table>
            <thead>
            <tr>
              <th>#</th>
              <th>متن خطا</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(error, i) in errorDialog.errors">
              <td>{{ i + 1 }}</td>
              <td>
                {{ error.text }}
              </td>
            </tr>
            </tbody>
          </v-simple-table>
          <v-row></v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import money from "@/components/mcomponents/cleave/Money";
import mtime from "@/components/mcomponents/cleave/Time";
import date from "@/components/mcomponents/cleave/Date";
import wareApiMixin from "@/mixin/wareApi";
import {MFormMixin} from "@/components/m-form";
import WarehouseHandlingTabs from "@/views/panel/warehouseHandling/WarehouseHandlingTabs";
import {mapState} from "vuex";

export default {
  name: "Form",
  components: {WarehouseHandlingTabs, money, date, mtime},
  mixins: [wareApiMixin, MFormMixin],
  props: ["id"],
  data() {
    return {
      baseUrl: "factors/warehouseHandlings",
      permissionBasename: "warehouseHandling",
      appendSlash: true,
      hasList: false,
      hasIdProp: true,
      hasLock: true,
      filters: {},
      inventory: [],
      inventoryClerks: [],
      rows: [],
    };
  },
  computed: {
    ...mapState({
      errorDialog: (state) => state.errorDialog,
    }),
    title(){
      return this.setDocumentTitle('ثبت انبار گردانی')
    }
  },
  watch: {
    filters: {
      handler() {
        this.getWareInventory();
      },
      deep: true,
    },
  },
  created() {
    this.getWares();
    this.getWarehouses();
    this.getInventoryClerk();
    this.filters = this.getFilterTemplate();
  },
  methods: {
    getInventoryClerk() {
      this.request({
        method: "get",
        url: this.endpoint("wares/inventory_clerk/"),
        success: (data) => {
          for (let inventory_clerk of data) {
            this.inventoryClerks.push({
              name: inventory_clerk.first_name + " " + inventory_clerk.last_name,
              id: inventory_clerk.id,
            });
          }
        },
      });
    },
    getWareInventory() {
      this.request({
        url: this.endpoint("reports/inventory/warehouse/all"),
        params: {
          ...this.filters,
          level: 3,
          limit: 1000000,
          offset: 0,
        },
        success: (data) => {
          data = data.results.slice(0, data.results.length - 1);
          this.inventory = data;
          if (!this.id) {
            this.rows = data.map((o) => {
              return {
                id: null,
                ware: o,
                system_remain: o.remain,
              };
            });
          }
        },
      });
    },
    definite() {
      this.request({
        url: this.endpoint("factors/warehouseHandlings/definite"),
        method: "post",
        data: {
          id: this.id,
        },
        success: (data) => {
          this.successResponse(data);
        },
      });
    },
    clearForm() {
      this.isEditing = true;
      this.item = this.getItemTemplate();
      this.filters = this.getFilterTemplate();
      this.changeRouteTo(null);
    },
    getFilterTemplate() {
      return {
        warehouse: null,
        level: 3,
        status: "all",
      };
    },
    getSystemRemain(row) {
      if (this.item.is_defined) {
        return row.system_remain;
      } else {
        return this.inventory.filter((o) => o.id == row.ware.id)[0]["remain"];
      }
    },
    getContradiction(row) {
      if (!row.warehouse_remain && row.warehouse_remain != 0) return "-";
      row.contradiction = row.warehouse_remain - this.getSystemRemain(row) || 0;
      return row.contradiction;
    },
    getContradictionStyle(row) {
      let contradiction = this.getContradiction(row);
      if (!row.warehouse_remain) return "";
      if (contradiction > 0) return "green--text";
      else return "red--text";
    },
    getItemTemplate() {
      return {};
    },
    setItem(item) {
      this.item = item;
      this.filters.warehouse = item.warehouse.id;
      this.filters.status = item.ware_status;
      this.itemsToDelete = [];
      this.rows = [];
      item.items
          .sort((a, b) => a.order - b.order)
          .forEach((item) => {
            let row = {...item};
            this.rows.push(row);
          });
      this.changeRouteTo(item.id);
      this.isEditing = false;
    },
    getSerialized() {
      let item = {
        ...this.item,
        warehouse: this.filters.warehouse,
        ware_status: this.filters.status,
      };
      let data = {
        item: this.extractIds(item),
        items: {
          ids_to_delete: this.itemsToDelete,
          items: this.rows.map((o) => this.extractIds(o)),
        },
      };
      return data;
    },
  },
};
</script>

<style scoped lang="scss"></style>
